








































import Vue from "vue";
import Toolbar from "../components/toolbar/Toolbar.vue";
import { ReadConfirmation } from "@infoland/iprova-api";
import storeHelper from "../store/store-helper";
import Shared from "../shared";
import Utils from "@/utils";
import { SnackBarTimeout } from "@/enums";
import moment from "moment";
import i18n from "./../plugins/i18n";

export default Vue.extend({
    name: "ReadList",
    components: { Toolbar },
    props: {},
    data: () => {
        return {};
    },
    computed: {
        readList(): ReadConfirmation[] {
            return storeHelper.readListStore.list;
        }
    },
    async beforeRouteEnter(to, from, next) {
        await storeHelper.readListStore.loadListAsync();
        if (storeHelper.readListStore.list && storeHelper.readListStore.list.length == 1) {
            if (from?.name == "ReadDocument" && !to?.params.fromReadNextDocument) {
                next({
                    name: "Tasks"
                });
            } else {
                next({
                    name: "ReadDocument",
                    params: { documentId: storeHelper.readListStore.list[0].document.document_id.toString() }
                });
                storeHelper.siteStore.setSnackBarMessage(i18n.t("readList.onlyDocument"), false, SnackBarTimeout.short);
            }
        } else {
            next();
        }
    },
    methods: {
        openDocument(readListItem: ReadConfirmation): void {
            this.$router.push({
                name: "ReadDocument",
                params: { documentId: readListItem.document.document_id.toString() }
            });
        },
        getDocumentIconUrl(document_id: string): String {
            return Shared.GetAuthenticatedUrl(`${Shared.iProvaApiUrl}/documents/${document_id}/icon`);
        },
        getFormattedDate(date: string): String {
            let itemDate = date.toDate();
            if (!moment(itemDate).isSame(moment(), "year")) {
                if (i18n.locale === "nl") return this.$t("readList.publishedOn") + moment(itemDate).format("D MMM YY").replace(".", "");
                else return this.$t("readList.publishedOn") + moment(itemDate).format("D MMM YY");
            }

            let dateFormatted = Utils.formatDateToCalendar(itemDate);

            if (i18n.locale === "nl") return this.$t("readList.publishedOn") + dateFormatted.replace(".", "");
            else return this.$t("readList.publishedOn") + dateFormatted;
        },
        showDivider(index: number): boolean {
            return this.readList && index + 1 < this.readList.length;
        }
    }
});
